import { render, staticRenderFns } from "./code-editor.html?vue&type=template&id=6d89c698&scoped=true&"
import script from "./code-editor.ts?vue&type=script&lang=ts&"
export * from "./code-editor.ts?vue&type=script&lang=ts&"
import style0 from "./code-editor.scss?vue&type=style&index=0&id=6d89c698&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d89c698",
  null
  
)

export default component.exports